import "./App.css";

export default function App() {
  return (
    <div className="site">
      <header className="hero">
        <img src="/logo.png" alt="AL Golf Logo" className="heroLogo" />

        {/* Your photo (make sure public/adam.jpg exists) */}
        <img src="/adam.jpg" alt="Adam Loose" className="profileImage" />

        <h1 className="heroName">Adam Loose</h1>
        <p className="heroRole">PGA Trainee Professional</p>
        <p className="heroTag">Improving On-Course Decision Making</p>

        <p className="heroIntro">
          Coaching golfers to think better on the course, make smarter decisions under pressure, and
          translate practice into lower scores where it matters most.
        </p>

        <div className="heroActions">
          <a className="btnPrimary" href="#contact">
            Get in Touch
          </a>
        </div>
      </header>

      <section className="section soft">
        <div className="wrap center">
          <h2 className="h2">Media & Social</h2>
          <p className="muted">
            Coaching insights, practice ideas, course strategy, and behind-the-scenes content across my
            social platforms.
          </p>

          <div className="socialGrid">
            <a
              className="socialItem"
              href="https://www.instagram.com/adam.l.golf/"
              target="_blank"
              rel="noreferrer"
            >
              <span className="socialIconTile">
                <img src="/icons/instagram.png" alt="Instagram" className="socialIcon" />
              </span>
              <span className="socialLabel">Instagram</span>
            </a>

            <a
              className="socialItem"
              href="https://www.youtube.com/@adam.l.golfer"
              target="_blank"
              rel="noreferrer"
            >
              <span className="socialIconTile">
                <img src="/icons/youtube.png" alt="YouTube" className="socialIcon" />
              </span>
              <span className="socialLabel">YouTube</span>
            </a>

            <a
              className="socialItem"
              href="https://www.linkedin.com/in/adam-loose-bbb276199/"
              target="_blank"
              rel="noreferrer"
            >
              <span className="socialIconTile">
                <img src="/icons/linkedin.png" alt="LinkedIn" className="socialIcon" />
              </span>
              <span className="socialLabel">LinkedIn</span>
            </a>
          </div>
        </div>
      </section>

      {/* About Me - sits directly under Media & Social */}
      <section className="section" id="about">
        <div className="wrap">
          <h2 className="h2 center">About Me</h2>
          <div className="coachCard">
            <p>
              I’m a PGA Trainee Professional based at Trump Turnberry, and I love competing.
            </p>
            <p>
              During university, I competed in the Premier Division of UK university golf, regularly playing
              against elite amateurs and aspiring professionals. I’ve also competed in Open Qualifying,
              gaining experience in championship environments where precision, course management, and mental
              control are critical.
            </p>
            <p>
              My development has taken place across contrasting elite settings. At Turnberry, I train and
              work within championship links conditions, while my time at The Buckinghamshire Golf Club
              exposed me to championship parkland golf and professional tournament environments. Experiencing
              both styles of golf at a high level has shaped my understanding of strategy, adaptability, and
              performance under pressure.
            </p>
            <p>
              Competing off a plus handicap, I understand what it feels like to perform when it matters. That
              competitive exposure shapes both my own preparation and the way I coach.
            </p>
            <p>
              Alongside playing, I graduated with First Class Honours in Golf Management, specialising in
              applied golf science, equipment technology, and performance analysis. I combine real competitive
              experience with modern performance data to help golfers improve in a way that genuinely
              transfers to the course.
            </p>
            <p className="emph">
              For me, technical skill matters — but decision making separates good golfers from consistent
              low scorers.
            </p>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="wrap">
          <h2 className="h2 center">How I Coach</h2>
          <div className="coachCard">
            <p>
              Most golfers are technically better than they think, but improvement often stalls because they
              are not fully aware of the shot they have in front of them. While most players understand areas
              of the course such as fairways, rough, greens, and bunkers, two balls sitting in the centre of
              the fairway can still require completely different decisions.
            </p>
            <p className="emph">Decision making is vital.</p>
            <p>
              My coaching takes place on the golf course, where I explain exactly which factors you need to
              take into account for each shot — so you can choose the right option, commit with confidence,
              and play smarter golf under real conditions.
            </p>
          </div>
        </div>
      </section>

      <section className="section" id="contact">
        <div className="wrap center">
          <h2 className="h2">Contact</h2>
          <p className="muted">
            For coaching enquiries, collaborations, or media requests, drop me an email and I’ll get back to you.
          </p>

          <a
            className="btnPrimary"
            href="https://mail.google.com/mail/?view=cm&fs=1&to=adamloose123@gmail.com&su=Coaching%20Enquiry"
            target="_blank"
            rel="noreferrer"
          >
            Email: adamloose123@gmail.com
          </a>
        </div>
      </section>

      <footer className="footer">
        © {new Date().getFullYear()} Adam Loose Golf. All rights reserved.
      </footer>
    </div>
  );
}